export default __webpack_public_path__ + "static/media/1419.420ab216.png";